

import {
  getCloseIconColor,
  getModalSurfaceColor,
  getPrimaryTextColor,
  palette,
} from "./colors";

// Delete Icons 
// without any border or box
export const deleteIconStyles =(visible:boolean)=> {
    return {
      marginLeft: "1rem",
      color: "red",
      padding: 0,
      visibility:visible? "visible": "hidden",
    }
}
export const listCircularProgressStyles = () => {
  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100%",
  }
}
export const actionButtonContainerStyles = () => {
  return {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  width: "100%",
  gap: "8px",
  }
}
export const actionButtonStyles = () => {
  return {
    padding: "5px",
    border: `1px solid ${palette.tabBorder}`,
    borderRadius: "0",
  }
}
export const renderCellWithLabelStyles = () => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  }
}

export const paperStyle = {
  overflow: "visible",
  mt: 1.5,
  p: 1.5,
  boxShadow: 3,
  borderRadius: "2px",
  "::before": {
    content: '""',
    position: "absolute",
    top: -10,
    left: 20,
    width: 0,
    height: 0,
    borderLeft: "10px solid transparent",
    borderRight: "10px solid transparent",
    borderBottom: "10px solid white",
    zIndex: 1,
  },
};

export const vendorItemStyle = (hasBorder: boolean) => ({
  paddingTop: "5px",
  paddingBottom: "5px",
  borderBottom: hasBorder ? `solid 1px ${palette.boxBorder}` : "none",
  cursor: "pointer",
  display: "flex",
  justifyContent: "left",
  alignItems: "left",
  gap: 2,
});

export const vendorTextStyle = {
  fontSize: 12,
  fontWeight: 600,
  color: palette.almostBlack,
};

export const fileContainerStyle = {
  border: `1px solid ${palette.inputField}`,
  padding: "0 1rem",
  height: "40px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}
export const fileNameStyle = {
  fontSize: "14px",
  fontWeight: 500,
  color: palette.natural,
  textTransform: "capitalize",
  maxWidth: 200,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}
export const fileButtonStyle = {
  boxShadow: "none",
  minWidth: 'auto', 
  fontSize: "14px",
  height: "auto",
  lineHeight: "16px",
  p: 0.5
  // minWidth: "80px",
}
export const getRedirectLinkStyles = (darkMode: boolean, disabled: boolean) => {
  return {
    width: "100%",
    height: "40px",
    border: `1px solid ${palette.inputField}`,
    backgroundColor: darkMode ? palette.dark3 : palette.white,
    color: darkMode ? palette.white : palette.black,
    display: "flex", alignItems: "center",
    justifyContent: "center",
    cursor: disabled ? "not-allowed" : "pointer",
  };
}

export const getModalPopupStyles = (darkMode: boolean) => {
  return {
    fontFamily: "Cerebri Sans",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "25.4px",
    align: "center",
    color: getPrimaryTextColor(darkMode),
  };
}

export const ModalBackgroundStyles = (darkMode: boolean) => {
  return {
    backgroundColor: getModalSurfaceColor(darkMode),
  }
}

export const getModalBodyTextStyles = (darkMode: boolean) => ({
  mt: 1,
  color: getPrimaryTextColor(darkMode),
});

export const getModalMessageStyles = (darkMode: boolean) => ({
  fontFamily: "Cerebri Sans",
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "25px",
  color: getPrimaryTextColor(darkMode),
  backgroundColor: getModalSurfaceColor(darkMode),
  paddingY: "16px",
  mx: "16px",
  borderBottom: `1px solid ${palette.boxBorder}`,
});

export const getModalQuestionStyles = (darkMode: boolean) => ({
  m: 0,
  fontFamily: "Cerebri Sans",
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "25px",
  color: getPrimaryTextColor(darkMode),
  whiteSpace: "normal",
  wordWrap: "break-word",
  overflowWrap: "break-word",
});

export const modalFormContentBoxStyles = (darkMode: boolean) => ({
  p: "16px",
  display: "flex",
  flexDirection: "column" as const,
  gap: 2,
  ...ModalBackgroundStyles(darkMode),
});

export const modalFooterBoxStyles = (darkMode: boolean) => ({
  display: "flex",
  justifyContent: "flex-end",
  px: "16px",
  py: "24px",
  gap: 2,
  ...ModalBackgroundStyles(darkMode),
});

export const wordBreakStyles =  {
  display: "inline", // Prevent block wrapping
  whiteSpace: "normal",
  wordBreak: "break-word",
  overflowWrap: "break-word",
}
export const modalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 644,
  bgcolor: palette.white,
  boxShadow: 24,
  outline: "none",
};

export const closeButtonColor = (darkMode: boolean) => {
  return { color: getCloseIconColor(darkMode) }
}

// File Upload/Download Button Styles
export const fileActionButtonStyles = (disabled: boolean = false) => {
  return {
    ...fileButtonStyle,
    opacity: disabled ? 0.6 : 1,
    cursor: disabled ? 'not-allowed' : 'pointer'
  }
}

export const fileActionButtonDeleteStyles = (isDeleting: boolean = false, disabled: boolean = false) => {
  return {
    ...fileButtonStyle,
    opacity: (isDeleting || disabled) ? 0.6 : 1,
    cursor: (isDeleting || disabled) ? 'not-allowed' : 'pointer'
  }
}